import { parseJSON, checkStatus } from '../../search-common/helpers'

// Constants.
export const REQUEST_IMAGES = 'REQUEST_IMAGES'
export const RECEIVE_IMAGES = 'RECEIVE_IMAGES'
export const FAILED_RECEIVE_IMAGES = 'FAILED_RECEIVE_IMAGES'

/**
 * Function returns an action object which
 * declares the start of an image fetch request.
 *
 * @return {object}
 */
const requestImages = () => ({
  type: REQUEST_IMAGES
})

/**
 * Function returns an action object which
 * contains the results of the image fetch request.
 *
 * @param {object} json
 * @return {object}
 */
export const receiveImages = ( json ) => ({
  type: RECEIVE_IMAGES,
  data: json
})

/**
 * Function returns an action object which
 * contains the error object if the image fetch
 * request failed.
 *
 * @param {object} error
 * @return {object}
 */
export const failedReceiveImages = ( error ) => ({
  type: FAILED_RECEIVE_IMAGES,
  data: error
})

/**
 * Function starts fetching the search results
 * if there is no previous fetch going on.
 */
export const fetchImagesIfNotBusy = () => {
  return ( dispatch, getState ) => {
    return dispatch( fetchImages( getState(), dispatch ))
  }
}

/**
 * Function fetches images
 *
 * @param {object} state
 */
const fetchImages = () => {
  const url = `${window.location.origin}/wp-json/sponda/v1/property_images`

  return ( dispatch ) => {
    dispatch( requestImages())
    return fetch( url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    )
      .then( checkStatus )
      .then( parseJSON )
      .then(( json ) => {
        dispatch( receiveImages( json ))
      })
      .catch(( error ) => {
        dispatch( failedReceiveImages( error ))
      })
  }
}
